import React, { useEffect, useState } from "react";
import { CiLocationOn, CiMail, CiStar } from "react-icons/ci";
import { FaRegClock } from "react-icons/fa";
import { HiOutlineClipboard } from "react-icons/hi2";
import { IoBookOutline } from "react-icons/io5";
import { LuCalendarDays } from "react-icons/lu";
import { MdOutlineGeneratingTokens } from "react-icons/md";
import { PiPhoneCallLight } from "react-icons/pi";
import "./TeacherProfileDetails.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const TeacherProfileDetails = () => {
  const { id } = useParams();
  const [teacherDetail, setTeacherDetail] = useState({});
  const [remark, setRemark] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/admin/teachers/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const data = response.data?.data || {};
        setTeacherDetail(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [API_BASE_URL, id]);

  const handleApprove = (id) => {
    axios
      .put(
        `${API_BASE_URL}/admin/teachers/${id}`,
        {
          approvalStatus: "approved",
          remark: "",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        alert(response.data.msg);
        navigate("/teacher-profile");
      })
      .catch((error) => {
        error?.response ? alert(error.response.data.msg) : alert(error.message);
      });
  };

  const handleReject = (id) => {
    axios
      .put(
        `${API_BASE_URL}/admin/teachers/${id}`,
        {
          approvalStatus: "rejected",
          remark: "",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        alert("Teacher Rejected");
        navigate("/teacher-profile");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div id="teacher-profile-details-container">
      <h4>Teacher Profile</h4>
      <div className="teacher-profile-details-inner-div">
        <div className="teacher-profile-details-card-container">
          <div className="teacher-profile-and-name">
            <div className="teacher-details">
              <p className="teacher-name">
                <b>{teacherDetail.basicInfo?.fullName}</b>
                <br />
                <span className="rating">
                  <CiStar /> <CiStar /> <CiStar /> <CiStar /> <CiStar />
                </span>
              </p>

              <div className="teacher-remark">
                <MdOutlineGeneratingTokens className="icon" />
                <input
                  type="text"
                  placeholder="approval/rejection Remark."
                  className="remark-input"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>

              <div className="action-buttons">
                <button
                  className="bg-success px-4 py-2 border border-0 text-light-emphasis"
                  onClick={() => handleApprove(teacherDetail._id)}
                >
                  Approve
                </button>
                <button
                  className="bg-danger px-4 py-2 border border-0 text-light-emphasis"
                  onClick={() => handleReject(teacherDetail._id)}
                >
                  Reject
                </button>
              </div>
            </div>
            <div className="teacher-profile-image-box">
              {teacherDetail.basicInfo?.profilePicture ? (
                <img
                  src={`${API_BASE_URL}/uploads/${teacherDetail.basicInfo?.profilePicture}`}
                  alt="teacher-img"
                />
              ) : (
                <div className="student-profile-student-image-box">
                  <img
                    src={require("../../../../Images/student-profile-img.png")}
                    alt="student-img"
                  />
                </div>
              )}
            </div>
          </div>

          <hr />

          <div className="teacher-details-sections">
            <div className="details-section">
              <h5>Basic Details</h5>
              <p className="contact-info">
                <span>
                  <PiPhoneCallLight className="icon" />{" "}
                  {teacherDetail.basicInfo?.contactNumber} ,{" "}
                  {teacherDetail.mobile}
                </span>
                <span>
                  <CiMail className="icon" /> {teacherDetail.basicInfo?.email}
                </span>
                <span>
                  <CiLocationOn className="icon" />
                  <span>{teacherDetail.basicInfo?.address}</span>
                </span>
              </p>
            </div>

            <div className="details-section">
              <h5>Professional Info</h5>
              <p>
                <span>Qualification : </span>
                <span>{teacherDetail.professionalInfo?.qualification}</span>
              </p>
              <p>
                <span>Experience : </span>
                <span>{teacherDetail.professionalInfo?.experience}</span>
              </p>
              <div className="classes-taught my-3">
                <span>
                  {teacherDetail.professionalInfo?.teachingDetails.map(
                    (item, idx) => (
                      <div key={idx}>
                        <HiOutlineClipboard className="icon" />
                        {item.className} -{" "}
                        <span>
                          <IoBookOutline className="icon" />
                          {item?.subjects.map((sub, idx) => (
                            <span key={idx}>{sub.subjectName} , </span>
                          ))}
                        </span>{" "}
                      </div>
                    )
                  )}
                </span>
              </div>
              {/* <p className="subjects">
                <span>
                  <IoBookOutline className="icon" />
                  {teacherDetail.professionalInfo?.teachingDetails.map(
                    (item, idx) => (
                      <span key={idx}>
                        {item.subjects.map((sub, idx) => (
                          <span key={idx}>{sub.subjectName} , </span>
                        ))}
                      </span>
                    )
                  )}
                </span>
              </p> */}
            </div>

            <div className="details-section">
              <h5>Additional Info</h5>
              <p className="additional-info">
                <span>
                  <LuCalendarDays className="icon" /> Days Available:{" "}
                  <b>
                    {teacherDetail.additionalInfo?.daysAvailable?.map(
                      (item, idx) => (
                        <span key={idx}>{item} , </span>
                      )
                    )}
                  </b>
                </span>
                <span>
                  <FaRegClock className="icon" /> Teaching Hours:{" "}
                  <b>
                    {teacherDetail.additionalInfo?.teachingHours?.map(
                      (item, idx) => (
                        <span key={idx}>{item} , </span>
                      )
                    )}
                  </b>
                </span>
              </p>
              <p>
                <h5>Bio : </h5>
                <span>{teacherDetail.additionalInfo?.bio}</span>
              </p>
              <p>
                <h5>Reference : </h5>
                <p>Name : {teacherDetail.additionalInfo?.reference?.name}</p>
                <p>
                  Contact : {teacherDetail.additionalInfo?.reference?.contact}
                </p>
                <p>
                  Relation : {teacherDetail.additionalInfo?.reference?.relation}
                </p>
              </p>
            </div>

            <div className="details-section">
              <h5>Aadhar Card Image</h5>
              <img
                src={`${API_BASE_URL}/uploads/${teacherDetail.basicInfo?.aadharFrontImage}`}
                alt="aadhar-front-side-image"
                className="teacher-aadhar-img"
              />
              <img
                src={`${API_BASE_URL}/uploads/${teacherDetail.basicInfo?.aadharBackImage}`}
                alt="aadhar-back-side-image"
                className="teacher-aadhar-img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherProfileDetails;
